<div class="flex flex-col md:flex-row px-5 md:px-12 lg:px-27 py-6 md:pt-4 md:pb-12 gap-6">
  <div *ngIf="person$ | async as personInfo; else personLoading"
       class="flex flex-col p-4 md:min-w-80 xl:min-w-98 h-full
       rounded-2xl shadow-md bg-background-primary text-text-primary">
    <div class="flex flex-row items-center pb-4 border-b">
      <div *ngIf="!avatarLoaded" class="min-w-20 w-20 h-20"></div>
      <img *ngIf="avatarLoaded && avatarUrl != null" [src]="avatarUrl" alt="Profile picture"
        class="object-cover rounded-full min-w-20 w-20 h-20" />
      <div *ngIf="avatarLoaded && avatarUrl == null"
        class="rounded-full flex justify-center items-center bg-gray-300 min-w-20 w-20 h-20">
        <mat-icon class="scale-[2]">person</mat-icon>
      </div>
      <div class="h3-text mx-4">{{personInfo.name}}</div>
    </div>

    <div *ngIf="personInfo.publishedRides > 0"
        class="flex justify-between items-center text-text-primary body-s-text border-b py-4">
      <div class="flex">
        <img src="assets/icons/dark/steering-wheel.svg" alt="icon"/>
        <span class="whitespace-nowrap ml-2" i18n>Rides published</span>
      </div>
      <span class="body-s-text-bold">{{personInfo.publishedRides}}</span>
    </div>
<!--        <div *ngIf="personInfo.publishedRides > 0"
          class="flex justify-between items-center text-text-primary body-s-text h-14" i18n>
       <img src="assets/icons/dark/truck.svg" alt="icon"/>
       <span i18n>Completed Bookings</span>
       <span class="mr-2 body-s-text-bold">{{personInfo.publishedRides}}</span>
     </div>-->
    <div *ngIf="personInfo.reviewCount > 0"
        class="flex justify-between items-center border-b py-4">
      <span class="body-s-text" i18n>Rating</span>
      <div class="flex flex-row items-center">
        <div class="flex flex-row">
          <div *ngFor="let ratingId of fiveStars; index as i">
            <img src="{{showIcon(i, personInfo.rating ?? 0)}}" class="h-6 w-6" alt=""/>
          </div>
        </div>
        <span class="ml-2 body-s-text-bold">{{personInfo.rating | number : '1.0-1'}}</span>
      </div>
    </div>
    <div *ngIf="personInfo.emailConfirmed"
        class="flex items-center body-s-text text-accent-blue border-b py-4">
      <img src="assets/icons/blue/verified-check.svg" alt="email"/>
      <span class="ml-2" i18n>Email confirmed</span>
    </div>
    <div *ngIf="personInfo.phoneConfirmed"
        class="flex items-center body-s-text text-accent-blue border-b py-4">
      <img src="assets/icons/blue/verified-check.svg" alt="phone"/>
      <span class="ml-2" i18n>Phone confirmed</span>
    </div>
    <div *ngIf="personInfo.drivingLicenseConfirmed"
        class="flex items-center body-s-text text-accent-blue border-b py-4">
      <img src="assets/icons/blue/verified-check.svg" alt="check"/>
      <span class="ml-2" i18n>Driving licence verified</span>
    </div>
    <div *ngIf="personInfo.professionalDriver"
        class="flex items-center body-s-text text-accent-blue border-b py-4">
      <img src="assets/icons/blue/certificate.svg" alt="check"/>
      <span class="ml-2" i18n>Professional driver</span>
    </div>
    <div class="flex justify-between items-center text-text-primary body-s-text py-4">
      <span i18n>Joined</span>
      <span class="body-s-text-bold mr-2">{{personInfo.memberSince | date: 'MMM yyyy'}}</span>
    </div>
  </div>
  <div *ngIf="showReviews" class="w-full">
    <app-person-reviews></app-person-reviews>
  </div>
  <ng-template #personLoading>
    <div class="w-full h-full flex justify-center items-center">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</div>